import { baseApi } from './axios';

export const getOrganisation = async ({ orgId }: { orgId?: string }) => {
	const response = await baseApi.get(`/organisations/details/${orgId}`);
	return response;
};
